/* @flow */

import { route } from 'preact-router';
import { type StateEndereco } from './types';
import { type GetState, type State } from '../../preact-app/types';
import { type EnderecoEntrega } from '../../enderecos/types';
import {
    SELECIONAR_CLIENTE,
    type SelecionarClienteAction,
} from './cliente';
import {
    LIMPAR_PEDIDO,
    CARREGAR_PEDIDO,
    type LimparPedidoAction,
    type CarregarPedidoAction,
} from './pedido';
import xhr from '../../utils/xhr';

const SELECIONAR_ENDERECO = 'balcao/endereco/SELECIONAR_ENDERECO';

type SelecionarEnderecoAction = {
    type: 'balcao/endereco/SELECIONAR_ENDERECO',
    endereco: EnderecoEntrega,
};

type Action =
    | SelecionarClienteAction
    | LimparPedidoAction
    | CarregarPedidoAction
    | SelecionarEnderecoAction;

// Utils

const getEnderecoPorId = (state: State, id: number): Promise<?EnderecoEntrega> => {
    const end = state.balcao.gridEnderecos.itens.find(endereco => id === endereco.id);
    if (end) {
        return Promise.resolve(end);
    }

    return xhr.get(`/enderecos/${id}`).then(({ data: endereco }) => endereco);
};

// Action Creators

export const selecionarEndereco = (endereco: EnderecoEntrega) => ({
    type: SELECIONAR_ENDERECO,
    endereco,
});

// Thunks

export const selecionarEnderecoPorId = (id: number) => async (
    dispatch: Function,
    getState: GetState,
) => {
    const endereco = await getEnderecoPorId(getState(), id);
    if (!endereco || !endereco.entrega) {
        return;
    }

    dispatch(selecionarEndereco(endereco));

    if (!getState().balcao.endereco) {
        return;
    }

    route('/balcao/produtos');
};

// Reducer

const enderecoReducer = (state: StateEndereco = null, action: Action): StateEndereco => {
    switch (action.type) {
    case SELECIONAR_ENDERECO:
        return action.endereco;
    case CARREGAR_PEDIDO: {
        const { pedido } = action;
        if (!pedido.endereco) {
            return null;
        }
        return {
            ...pedido.endereco,
            entrega: true,
            prazo: 0,
            valor: pedido.taxaEntrega || 0,
        };
    }
    case LIMPAR_PEDIDO:
    case SELECIONAR_CLIENTE:
        return null;
    default:
        return state;
    }
};

export default enderecoReducer;
